<template>
  <div class="home">
    <a href="/jisao">云祭扫</a><br />
    <a href="/about">官网</a><br />
    <a href="/shop">商城</a><br />
    <a href="/jnt">纪念堂</a>
  </div>
</template>

<script>
import WeixinModel from '@/api/WeixinModel'
export default {
  name: 'Home',
  data() {
    return {
      danren:true,
      showFirstBirth: false,
      showFirstDeath: false,
      showSecondBirth: false,
      showSecondDeath: false,
      formData:{
        myId: this.$store.getters.userId,
        category: 'siren',
        hallCount: "1",
        firstPhoto: '',
        firstName: '',
        firstBirthDate: '',
        firstDeathDate: '',
        secondPhoto: '',
        secondName: '',
        secondBirthDate: '',
        secondDeathDate: '',
      }
    }
  },
  created(){
    console.log('0...')
    console.log(this.$store.getters.isLogin)
    console.log('1...')
    console.log(WeixinModel.getTest())
    // this.$store.dispatch('user',{id:0})
    // console.log(this.$store.getters.userid)
  },
  methods:{
    afterFirstRead(file) {
      alert('1:'+JSON.stringify(file))
      // this.$upload('MemHall', file, function(res) {
      //   alert('2:'+JSON.stringify(res))
      //   // console.log(JSON.stringify(res))
      //   // that.formData.secondPhoto = res['data']['url']
      // }, function(res){
      //   alert('error')
      // })
    }
  }
}
</script>

<style>
.home {
  text-align: center;
  line-height: 40px;
}
.publish-box .uploader-img {
  padding: 0 15px;
  margin-top: 10px;
  padding-bottom: 10px;
  position: relative;
}
</style>
